import { ref } from "vue";
import { R3DropdownClass } from "~/classes/base/R3Dropdown.classes";
import { R3CalendarClass } from "~/classes/base/R3Calendar.classes";
import { R3LabelClass } from "~/components/R3/R3Label/classes/R3Label.classes";
import { R3FieldSetClass } from "~/classes/base/R3FieldSet.classes";
import { R3DataFinderClass } from "~/classes/base/R3DataFinder.classes";
import { R3PanelClass } from "~/components/R3/R3Div/classes/R3Panel.classes";
import R3ButtonClass from "~/components/R3/Button/classes/R3Button.classes";
import type { DF_E577Response } from "@r3shared/types/datafinders/responses/DF_E577.types";
import {
	R3InputNumberClass,
	R3InputTextClass,
} from "../base/R3InputBase.classes";


type dataFindersRecebimento = "DF_E577" | "DF_E722";
type moduColetorSearchesRecebimento = "E577_SaldoMov" | "E577_Saldo_EmpCarregItem";

export class RecebimentoTabClass {
	fieldSetMercadoria = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputMercadoria = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	dataFinderMercadoriaRef = autoRef<R3DataFinderClass>(new R3DataFinderClass());
	fieldSetLastro = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputLastro = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	fieldSetCamada = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputCamada = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	fieldSetNorma = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputNorma = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	panelAcondicionamentoSemiAutomatico = autoRef<R3PanelClass>(
		new R3PanelClass(),
	);
	fieldsetAcondicionaNoPicking = autoRef<R3FieldSetClass>(
		new R3FieldSetClass(),
	);
	acondicionaPickingSemiAutomaticoDropdown = autoRef<
		R3DropdownClass<"S" | "N">
	>(new R3DropdownClass<"S" | "N">());
	fieldSetAltura = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputAltura = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	fieldSetQtdCaixa = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputQtdCaixa = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	fieldSetEmbalagemPadrao = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputEmbalagemPadrao = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	fieldSetQtdUnidade = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputQtdUnidade = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	fieldSetFormaRecebimento = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	formaRecebimentoDropdown = autoRef<R3DropdownClass<string>>(
		new R3DropdownClass<string>(),
	);
	fieldSetQtdTotalUnidades = autoRef<R3FieldSetClass>(new R3FieldSetClass());

	inputQtdTotalUnidade = autoRef<R3InputNumberClass>(
		new R3InputNumberClass(null, "QtdTotalUnidade"),
	);

	fieldSetMotivoAvaria = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputMotivoAvaria = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	dataFinderMotivoAvariaRef = autoRef<R3DataFinderClass>(
		new R3DataFinderClass(),
	);
	fieldSetAvaria = autoRef<R3FieldSetClass>(new R3FieldSetClass());
	inputQtdAvariaRef = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	dataFinderQtdAvariaRef = autoRef<R3DataFinderClass>(new R3DataFinderClass());
	fieldSetLoteFabricacao = autoRef(new R3FieldSetClass());
	inputLoteFabricacao = autoRef<R3InputNumberClass>(new R3InputNumberClass());
	labelPesoVariavel = autoRef<R3LabelClass>(
		new R3LabelClass({
			initialVisible: false,
		}),
	);
	labelValidadePicking = autoRef<R3LabelClass>(new R3LabelClass());
	fieldSetDataValidade = autoRef<R3DataFinderClass>(new R3DataFinderClass());
	calendarValidade = autoRef<R3CalendarClass>(new R3CalendarClass());
	loteFabricacaoDataFinder = autoRef<R3DataFinderClass>(
		new R3DataFinderClass(),
	);
	confButton = autoRef<R3ButtonClass>(new R3ButtonClass());
	panelValidade = autoRef<R3PanelClass>(new R3PanelClass());
	// @keep
	visible = ref<boolean>(true);
	// @keep
	dataFinderMercadoriaResult: DF_E577Response = autoRef<DF_E577Response>(null);
	// @keep
	pickingAcondicionadoPaletizacaoDropdown = autoRef<R3DropdownClass<"S" | "N">>(
		new R3DropdownClass<"S" | "N">(),
	);
	// @keep
	onConferirButtonClick: (() => Promise<void>) | null = null;
	// @keep
	conferirPeloUMA = ref<boolean>(false);

	exibiuMsgShelfLife = ref(false);

	// @keep
	datafinders = new Map<dataFindersRecebimento, unknown>();
	// @keep
	moduColetorResults = new Map<moduColetorSearchesRecebimento, unknown>();
	// @keep
	getTypedDatafinders<T>(key: dataFindersRecebimento): T {
		return this.datafinders.get(key) as T;
	}
	// @keep
	getTypedModuColetorResult<T>(key: moduColetorSearchesRecebimento): T {
		return this.moduColetorResults.get(key) as T;
	}

	// @keep - Armazena o resultado de um DataFinder
	setDatafinder(key: dataFindersRecebimento, value: unknown): void {
		this.datafinders.set(key, value);
	}

	// @keep - Armazena o resultado de uma consulta MODU_COLETOR
	setModuColetorResult(key: moduColetorSearchesRecebimento, value: unknown): void {
		this.moduColetorResults.set(key, value);
	}

}
